import { CustomValidationError } from '@fulcrumapp/fulcrum-core';

export default function processValidation(result) {
  return new CustomValidationError(result);
}
